import { isEmptyObject } from "@ciq/shared/utils/object"
import { FeatureFlags } from "@ciq/shared/constants/featureFlags"

/**
 * Checks if map view should be available based on both institution-level
 * (PostHog feature flag) and user-level (can_view_map claim) permissions.
 *
 * @param {Function} isFeatureEnabled - PostHog feature flag check
 * @param {Function} getFeaturePayload - PostHog feature payload getter
 * @param {string} schoolId - Current school ID
 * @param {Object} views - User permission views
 * @returns {boolean} Whether map view should be shown
 */
export const hasMapView = (isFeatureEnabled, getFeaturePayload, schoolId, views) => {
  if (isEmptyObject(schoolId)) {
    return false
  }

  if (!views?.can_view_map) {
    return false
  }

  if (isFeatureEnabled(FeatureFlags.map_view_for_all)) {
    return true
  }

  if (isFeatureEnabled(FeatureFlags.map_view_by_school)) {
    const payload = getFeaturePayload(FeatureFlags.map_view_by_school.flagKey)
    if (!payload?.school_ids) {
      return false
    }

    return payload.school_ids.includes(schoolId)
  }

  return false
}
